import { createSlice } from '@reduxjs/toolkit';
import { OverviewIntervalsStateType } from 'src/types/overviewIntervals';

const initialState: OverviewIntervalsStateType = {
    ordersDataActual: null,
    ordersDataPrevious: null,
    receivingsDataActual: null,
    receivingsDataPrevious: null,
    returnsDataActual: null,
    returnsDataPrevious: null,
    claimsDataActual: null,
    claimsDataPrevious: null,
    data: null,
    loading: false,
    loadingType: false,
    orderInStatusesData: null,
    loadingOrdersInStatuses: false,
    deliveredOrders: 0
};
export const overviewIntervalSlice = createSlice({
    name: 'overviewInterval',
    initialState,
    reducers: {
        getOverviewIntervalDataFetch: (state, action) => {
            state.loading = true;
            state.data = null;
        },
        getOverviewIntervalDataFetchSuccess: (state, action) => {
            if (action.payload.ordersDataActual) {
                state.ordersDataActual = action.payload.ordersDataActual;
            }
            if (action.payload.ordersDataPrevious) {
                state.ordersDataPrevious = action.payload.ordersDataPrevious;
            }
            if (action.payload.receivingsDataActual) {
                state.receivingsDataActual = action.payload.receivingsDataActual;
            }
            if (action.payload.receivingsDataPrevious) {
                state.receivingsDataPrevious = action.payload.receivingsDataPrevious;
            }
            if (action.payload.returnsDataActual) {
                state.returnsDataActual = action.payload.returnsDataActual;
            }
            if (action.payload.returnsDataPrevious) {
                state.returnsDataPrevious = action.payload.returnsDataPrevious;
            }
            if (action.payload.claimsDataActual) {
                state.claimsDataActual = action.payload.claimsDataActual;
            }
            if (action.payload.claimsDataPrevious) {
                state.claimsDataPrevious = action.payload.claimsDataPrevious;
            }
            if (
                state.ordersDataActual !== null &&
                state.ordersDataPrevious !== null &&
                state.receivingsDataActual !== null &&
                state.receivingsDataPrevious !== null &&
                state.returnsDataActual !== null &&
                state.returnsDataPrevious !== null &&
                state.claimsDataActual !== null &&
                state.claimsDataPrevious !== null
            ) {
                state.loading = false;
            }
        },
        getOverviewIntervalDataFetchFailure: (state, action) => {
            state.loading = false;
        },

        getOverviewIntervalTypeDataFetch: (state, action) => {
            state.loadingType = true;
        },
        getOverviewIntervalTypeDataFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loadingType = false;
        },
        getOverviewIntervalTypeDataFetchFailure: (state, action) => {
            state.loadingType = false;
        },

        getOverviewIntervalOrdersInStatusesFetch: (state) => {
        },
        getOverviewIntervalOrdersInStatusesFetchSuccess: (state, action) => {
            state.orderInStatusesData = action.payload.data;
        },
        getOverviewIntervalOrdersInStatusesFetchFailure: (state, action) => {
        },

        getOverviewIntervalOrdersDeliveredFetch: (state, action) => {
            state.loadingOrdersInStatuses = true;
            state.deliveredOrders = 0;
        },
        getOverviewIntervalOrdersDeliveredFetchSuccess: (state, action) => {
            state.deliveredOrders = action.payload.data;
            state.loadingOrdersInStatuses = false;
        },
        getOverviewIntervalOrdersDeliveredFetchFailure: (state, action) => {
            state.deliveredOrders = 0;
            state.loadingOrdersInStatuses = false;
        }
    }
});

export const {
    getOverviewIntervalDataFetch,
    getOverviewIntervalDataFetchSuccess,
    getOverviewIntervalDataFetchFailure,
    getOverviewIntervalTypeDataFetch,
    getOverviewIntervalTypeDataFetchSuccess,
    getOverviewIntervalTypeDataFetchFailure,
    getOverviewIntervalOrdersInStatusesFetch,
    getOverviewIntervalOrdersInStatusesFetchSuccess,
    getOverviewIntervalOrdersInStatusesFetchFailure,
    getOverviewIntervalOrdersDeliveredFetch,
    getOverviewIntervalOrdersDeliveredFetchSuccess,
    getOverviewIntervalOrdersDeliveredFetchFailure
} = overviewIntervalSlice.actions;

export default overviewIntervalSlice.reducer;
